module.exports = __webpack_public_path__ + "img/PA.5621bbb0.svg";